import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DPV_CODE } from '@cart-checkout/checkout/data-access/enums';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { CheckoutAnalyticsService } from '@cart-checkout/data-access/services';

@Component({
	standalone: true,
	imports: [CommonModule, HmfButtonComponent],
	selector: 'cart-checkout-checkout-components-suggested-address-modal',
	templateUrl: './suggested-address-modal.component.html',
	styleUrls: ['./suggested-address-modal.component.scss']
})
export class SuggestedAddressModalComponent {
	constructor(
		private dialogRef: MatDialogRef<SuggestedAddressModalComponent>,
		private checkoutAnalyticsService: CheckoutAnalyticsService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	get unverifiedAddress() {
		return this.data?.avsResponse?.unverifiedAddress;
	}

	get suggestedAddress() {
		return this.data?.avsResponse?.verifiedAddress;
	}

	get names() {
		return this.data?.names;
	}

	buttonClicked(decision: boolean) {
		this.checkoutAnalyticsService.triggerAnalyticsEvent(decision ? 'AvsV2:SuggestedAddress:UseSuggestedAddressButtonClick' : 'AvsV2:SuggestedAddress:EditAddressButtonClick', {
			dpvCode: DPV_CODE.INVALID_ADDRESS
		});
		this.dialogRef.close(decision);
	}

	close() {
		this.dialogRef.close();
	}
}
